var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPacman(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "transparent",
      display: "block"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 50,
    r: 4,
    fill: "#f7f7f7"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    repeatCount: "indefinite",
    dur: "1s",
    values: "95;35",
    keyTimes: "0;1",
    begin: "-0.67s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0;1;1",
    keyTimes: "0;0.2;1",
    begin: "-0.67s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 50,
    r: 4,
    fill: "#f7f7f7"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    repeatCount: "indefinite",
    dur: "1s",
    values: "95;35",
    keyTimes: "0;1",
    begin: "-0.33s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0;1;1",
    keyTimes: "0;0.2;1",
    begin: "-0.33s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 50,
    r: 4,
    fill: "#f7f7f7"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    repeatCount: "indefinite",
    dur: "1s",
    values: "95;35",
    keyTimes: "0;1",
    begin: "0s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0;1;1",
    keyTimes: "0;0.2;1",
    begin: "0s"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 50L20 50A30 30 0 0 0 80 50Z",
    fill: "#c770f0",
    transform: "rotate(90 50 50)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 50L20 50A30 30 0 0 0 80 50Z",
    fill: "#c770f0"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0 50 50;45 50 50;0 50 50",
    keyTimes: "0;0.5;1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50 50L20 50A30 30 0 0 1 80 50Z",
    fill: "#c770f0"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0 50 50;-45 50 50;0 50 50",
    keyTimes: "0;0.5;1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacman);
export default __webpack_public_path__ + "static/media/pacman.6ca165617d1b6575ba4050c208d77dec.svg";
export { ForwardRef as ReactComponent };